import { BaseSite, TagCategory } from '../common';
import { SiteType } from './enums/';

export enum SiteUpdatableAttribute {
  name = 'name',
  customerNumber = 'customerNumber',
  address1 = 'address.address1',
  country = 'address.country',
  state = 'address.state',
  city = 'address.city',
  zipCode = 'address.zipCode'
}

export interface Site extends BaseSite {
  allAssetsDecommissioned?: boolean;
  allDevicesDecommissioned?: boolean;
  expandedTagCategories: { [tagCategoryId: string]: TagCategory };
  name2?: string;
  totalAssetActiveEvents?: number;
  totalDeviceActiveEvents?: number;
  updatableAttributes: SiteUpdatableAttribute[];
  type: SiteType;
  tags?: string[];
}

export interface SiteFromERP {
  city: string;
  country: string;
  countryCode: string;
  division: string;
  houseNumber: string;
  maintenancePlant: string;
  name1: string;
  name2: string;
  postalCode: string;
  region: string;
  shipToAccountNumber: string;
  state: string;
  status: string;
}

export const ERPs = ['SAP AIRGAS'];
export const SITE_TYPES = [SiteType.PRODUCTION_SITE, SiteType.CUSTOMER_SITE];
